import { render } from "./struktur_organisasi.vue?vue&type=template&id=cd700d6a"
import script from "./struktur_organisasi.vue?vue&type=script&lang=js"
export * from "./struktur_organisasi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__